import { gql } from "@apollo/client";

export const CREATE_AND_UPDATE_PROFESIONAL = gql`
    mutation CreateAndUpdateProfesional($input: AddConProfesionalInput!) {
        createAndUpdateProfesional(profesionalInput: $input) {
            valorEsperado{
                idProfesional
            }
            success
            error
        }
    }
`;

export const adaptProfesional = (idProfesional, datosGeneralesFormData, datosContactoFormData, datosSeleccionFormData, delegacionFormData) => {
  return {
    profesional: {
      idProfesional: idProfesional,
      idTipoProfesional: datosGeneralesFormData?.idTipoProfesional,
      activo: !!datosGeneralesFormData?.activo,
      idFuncion: datosGeneralesFormData?.idFuncion,
      idEspecialidad: datosGeneralesFormData?.idEspecialidad,
      cod_SAP: datosGeneralesFormData?.cod_Proveedor || null,
      idTipoDocumento: datosGeneralesFormData?.idTipoDocumento,
      fechaNac: datosGeneralesFormData?.fechaNacimiento,
      sexo: datosGeneralesFormData?.sexo,
      cUIT: datosGeneralesFormData?.cuitL?.toString(),
      email: datosGeneralesFormData?.email,
      observacion: datosGeneralesFormData?.observacion,
      nombre: datosGeneralesFormData?.nombre,
      apellido: datosGeneralesFormData?.apellido,
      numeroDoc: datosGeneralesFormData?.numeroDoc,
      cuitSAP: datosGeneralesFormData?.cuitSAP,
      realizaRI: datosGeneralesFormData?.realizaRI,
      fidelizado: !!datosGeneralesFormData?.fidelizado,
      ejerceFonoaudiologo: !!datosGeneralesFormData?.ejerceFonoaudiologo,
      ejerceKinesiologo: !!datosGeneralesFormData?.ejerceKinesiologo,

      certificadoVacunacion: datosSeleccionFormData?.certificadoVacunacionCheck,
      tituloHabilitante: datosSeleccionFormData?.tituloHabilitanteCheck,
      firmoContrato: datosSeleccionFormData?.firmoContratoCheck,
      puntosSeleccion: datosSeleccionFormData?.puntosSeleccion,
      idResultadoSeleccion: datosSeleccionFormData?.idResultadoSeleccion,
      curriculum: datosSeleccionFormData?.curriculumCheck,
      observacionVacunacion: datosSeleccionFormData?.observacionVacunacion,
      idDelegacionMonitoreo: delegacionFormData?.idDelegacionMonitoreo,
      idDelegaciones: Array.isArray(delegacionFormData?.delegaciones) ? delegacionFormData?.delegaciones?.map((delegacion) => {return { key: delegacion, value: true };}) : [],
      datoContactoProfesional: {
        calle: datosContactoFormData?.calle,
        numero: datosContactoFormData?.numero,
        piso: datosContactoFormData?.piso,
        unidad: datosContactoFormData?.unidad,
        cP: datosContactoFormData?.codigoPostal,
        idLocalidad: datosContactoFormData?.idLocalidad,
        latitud: datosContactoFormData?.latitud,
        longitud: datosContactoFormData?.longitud,
        telefonoMovil: datosContactoFormData?.telefonoMovil,
        telefonoParticular: datosContactoFormData?.telefonoParticular,
        telefonoLaboral: datosContactoFormData?.telefonoLaboral,
        observaciones: datosContactoFormData?.observacion
      }
    },
    matriculas: Array.isArray(datosSeleccionFormData?.matriculas) ? datosSeleccionFormData?.matriculas?.map((matricula) => {
      return {
        idOrigenMatricula: matricula.idOrigenMatricula,
        fechaVencimiento: matricula.fechaVencimiento,
        numero: matricula.numero
      };
    }) : [],
  };
};

export const adaptDocumento = (documento) => {
  return {
    idArchivo: documento?.idArchivo,
    contentType: documento?.contentType,
    titulo: documento?.titulo,
    archivo: documento?.archivo,
    extension: documento?.extension
  };
};